/*CUSTOM Javascript ES6*/
(function () {

  /* =============================================================================
           Common functions
  ============================================================================= */
  //Absolute Url for fetch ajax enquiry
  var getUrl;
  getUrl = window.location.protocol + '//' + window.location.hostname + '/';

  let isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
      return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
  };


  function getOrientation() {
    // if window.orientation is available...
    if (window.orientation && typeof window.orientation === 'number') {

      // ... and if the absolute value of orientation is 90...
      if (Math.abs(window.orientation) == 90) {
        // ... then it's landscape
        return 'landscape';
      } else {
        // ... otherwise it's portrait
        return 'portrait';
      }

    } else {
      return false; // window.orientation not available
    }
  }


  const hasClass = (elem, className) => {
    return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
  }

  const addClass = (elem, className) => {
    if (!hasClass(elem, className)) {
      elem.className += ' ' + className;
    }
  }

  if (isMobile.Android()) {
    //$("body").addClass("android");
    addClass(document.querySelector('body'), 'android');
  }

  if (isMobile.iOS()) {
    //$("body").addClass("ios");
    addClass(document.querySelector('body'), 'ios');
  }

  const show = (elem) => {
    elem.style.display = 'block';
  }

  const showflex = (elem) => {
    elem.style.display = 'flex';
  }

  // Hide an element
  const hide = (elem) => {
    elem.style.display = 'none';
  }

  const FormDataToJSONString = (form) => {
    var obj = {};
    var elements = form.querySelectorAll("input, select, textarea");
    for (var i = 0; i < elements.length; ++i) {
      var element = elements[i];
      var name = element.name;
      var value = element.value;

      if (name) {
        obj[name] = value;
      }
    }
    return JSON.stringify(obj);
  }

  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  /* =============================================================================
         Form data and submissions
  ============================================================================= */
  const form = document.getElementById("booking");

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      let hotel = document.getElementById("hotel");
      let checkIn = document.getElementById("arrival");
      let arrival = document.getElementById("arrival").value;
      let checkOut = document.getElementById("departure");
      let departure = document.getElementById("departure").value;

      var totalNights = Math.floor((Date.parse(departure) - Date.parse(arrival)) / 86400000);

      let error = false;


      if (arrival === "" || arrival === " ") {
        show(document.getElementById("err-arrival"));
        arrival.focus();
        error = true; // change the error state to true
        return false;
      }

      if (departure === "" || departure === " ") {
        show(document.getElementById("err-departure"));
        departure.focus();
        error = true; // change the error state to true
        return false;
      }


      if (error == false) {
        //hide(document.getElementById("err-hotel"));
        hide(document.getElementById("err-arrival"));
        hide(document.getElementById("err-departure"));

        let url = 'https://all.accor.com/ssr/app/accor/hotels/singapore/index.en.shtml' + '?dateIn=' + arrival + '&nights=' + totalNights;


        // function getCookie(name) {

        var clickId = getCookie("ken_gclid");
        // var nameEQ = "ken_gclid=";
        // var ca = document.cookie.split(';');
        // var clickId;
        // for (var i = 0; i < ca.length; i++) {
        //   var c = ca[i];
        //   while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        //   if (c.indexOf(nameEQ) === 0) {
        //     clickId = c.substring(nameEQ.length, c.length);
        //   }
        //   ;
        // }
        // return null;
        // }

        if (clickId) {
          var separator = "?";
          if (url.indexOf("?") >= 0) {
            separator = "&"
          }
          url = url + separator + "gclid=" + clickId;
        }









        window.open(url);

      }

    }, false);// on submit
  }


  /* =============================================================================
      Content Amimations
  ============================================================================= */

  function reveal() {
    var elements = document.querySelectorAll(".reveal, .slideinleft, .slideinright,.slideintop");

    for (var i = 0; i < elements.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = elements[i].getBoundingClientRect().top;
      var elementVisible = 150;

      if (elementTop < windowHeight - elementVisible) {
        elements[i].classList.add("active");
      } else {
        elements[i].classList.remove("active");
      }
    }
  }

  // Get the button:
  let mybutton = document.getElementById("btt_button");
  window.onscroll = function () {
    scrollFunction()
  };

  function scrollFunction() {
    if (document.body.scrollTop > 300 || document.documentElement.scrollTop > 300) {
      mybutton.classList.add("show");
    } else {
      mybutton.classList.remove("show");
    }
  }

  mybutton.addEventListener('click', function (e) {
    e.preventDefault();
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  });

  window.addEventListener("scroll", reveal);

  reveal(); // onload

  let ctrlVideo = document.getElementById("player");
  let play_video = document.getElementById("play_video");
  if (play_video) {
    play_video.addEventListener('click', function (e) {
      if (play_video.classList.contains("active")) {
        ctrlVideo.play();
        play_video.classList.remove("active");
      } else {
        ctrlVideo.pause();
        play_video.classList.add("active");
      }
    });
  }


  /* =========================================================
      Scroll to Content
  ============================================================*/

  const scrolldown = document.getElementById('scrolldown');
  const introcontent = document.getElementById('bg');

  // Add a click event listener to the button
  if (scrolldown) {
    scrolldown.addEventListener('click', function (e) {
      e.preventDefault();
      // Scroll to the target section when the button is clicked
      introcontent.scrollIntoView({behavior: 'smooth'}); // Use 'smooth' for smooth scrolling
    });
  }


  // onclick of reservebtn
  const reservebtn = document.getElementById('reservebtn');
  const spotnow = document.getElementById('spotnow');

  if (reservebtn) {
    reservebtn.addEventListener('click', function (e) {
      e.preventDefault();
      // Scroll to the target section when the button is clicked
      spotnow.scrollIntoView({behavior: 'smooth'}); // Use 'smooth' for smooth scrolling
    });
  }


  /* =========================================================
     Swiper library
  ============================================================*/

  // Detect screen width
  const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

//main page partners swipe
  const sliderSwiper = new Swiper(".swiper-masthead", {
    loop: true
  });

  //main page partners swipe
  const partnerSwiper = new Swiper(".partnerSwiper", {
    slidesPerView: 2, // Set to 1 for mobile responsiveness
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      // Customize swiper options for different screen sizes
      640: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
      },
    },
  });

  //main page last section only for mobiles.
  const experienceSwiper = new Swiper(".experienceSwiper", {
    slidesPerView: 3, // Set to 1 for mobile responsiveness
    spaceBetween: 5,
    breakpoints: {
      // Customize swiper options for different screen sizes
      640: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 4,
      },
    },
  });

  //detail page unique bites swipe
  const swiper = new Swiper('.accorSwiper', {
    // Swiper options here
    slidesPerView: 1,
    grabCursor: true,
    effect: 'fade', //creative fade
    fadeEffect: {
      crossFade: true // Enable cross-fade transition
    },
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },


  });

  let slides = document.querySelectorAll('.swiper-slide');
  let customNextButton = document.querySelector('.custom-next-button');
  let customPrevButton = document.querySelector('.custom-prev-button');

  function updatePlaceholderImage() {
    let activeSlide = slides[swiper.activeIndex];

    // Update the custom arrow buttons if they exist
    if (customNextButton) {

      let nextIndex = swiper.activeIndex + 1;
      console.log('nextIndex', nextIndex);
      if (nextIndex >= slides.length) {
        nextIndex = 0;
      }

      if (nextIndex < slides.length) {
        customNextButton.style.backgroundImage = `url(${slides[nextIndex].querySelector('.mainimage img').src})`;
      } else {
        customNextButton.style.backgroundImage = '';
      }
    }

    if (customPrevButton) {
      let prevIndex = swiper.activeIndex - 1;
      console.log('prevIndex', prevIndex);
      if (prevIndex < 0) {
        prevIndex = slides.length - 1;
      }
      if (prevIndex >= 0) {
        customPrevButton.style.backgroundImage = `url(${slides[prevIndex].querySelector('.mainimage img').src})`;
      } else {
        customPrevButton.style.backgroundImage = '';
      }
    }

  }


  if (swiper) {
    swiper.on('slideChange', function () {
      updatePlaceholderImage();
    });
  }

  if (customNextButton) {
    customNextButton.addEventListener('click', function () {
      console.log('nextclick');
      // Calculate the index of the next slide
      let nextIndex = swiper.activeIndex + 1;

      console.log(nextIndex, "nextIndex");

      // If we reach the last slide, wrap around to the first slide
      if (nextIndex >= slides.length) {
        nextIndex = 0;
      }

      swiper.slideTo(nextIndex); // Go to the next slide
      updatePlaceholderImage();
      // console.log("next");
    });
  }

  if (customPrevButton) {
    customPrevButton.addEventListener('click', function () {
      console.log('prevclick');
      // Calculate the index of the previous slide
      let prevIndex = swiper.activeIndex - 1;

      console.log(prevIndex, "prevIndex");

      // If we reach the first slide, wrap around to the last slide
      if (prevIndex < 0) {
        prevIndex = slides.length - 1;
      }

      swiper.slideTo(prevIndex); // Go to the previous slide
      updatePlaceholderImage();

      // console.log("prev");
    });
  }

  //initialize
  if (customNextButton && customPrevButton) {
    updatePlaceholderImage();
  }


  // for mobile  dropdown
  // JavaScript to toggle the visibility of sections based on the dropdown selection
  const sectionDropdown = document.getElementById('section-dropdown');
  const section1Panel = document.getElementById('one-panel');
  const section2Panel = document.getElementById('two-panel');
  const section3Panel = document.getElementById('three-panel');

  if (sectionDropdown) {
    sectionDropdown.addEventListener('change', () => {
      const selectedValue = sectionDropdown.value;

      // Hide all panels
      section1Panel.style.display = 'none';
      section2Panel.style.display = 'none';
      section3Panel.style.display = 'none';

      // Show the selected panel
      if (selectedValue === 'section1') {
        section1Panel.style.display = 'block';
      } else if (selectedValue === 'section2') {
        section2Panel.style.display = 'block';
      } else if (selectedValue === 'section3') {
        section3Panel.style.display = 'block';
      }
    });
  }

  const player = new Plyr('#player', {
    debug: true,
    volume: 0,
    autoplay: true
  })

  /* =========================================================
    Footer links in accordion format linksList
     ============================================================*/

  document.addEventListener("DOMContentLoaded", function () {
    let e = document.querySelectorAll(".footerComponent .linksList")[0];
    if (e) {
      let n = e.getElementsByClassName("linksList__ul"),
          t = e.getElementsByClassName("linksList__btn");
      e.addEventListener("click", (function (e) {
        let r = e.target;
        if ("button" === r.tagName.toLowerCase()) {
          let e = r.closest(".linksList__list").querySelector(".linksList__ul"),
              o = !1;
          e.matches(".open") || (o = !0);
          for (let e in n) n.hasOwnProperty(e) && n[e].classList.remove("open");
          for (let e in t) t.hasOwnProperty(e) && (t[e].setAttribute("aria-expanded", !1), t[e].classList.remove("open"));
          if (o && !e.matches(".open")) {
            let n = r.closest(".linksList__list").querySelector(".linksList__btn");
            n.setAttribute("aria-expanded", !0), n.classList.add("open"), e.style.display = "block", setTimeout((function () {
              e.classList.add("open")
            }), 10)
          }
        }
      }), !1);
      for (let e in n) n.hasOwnProperty(e) && n[e].addEventListener("transitionend", (function () {
        this.matches(".open") || (this.style.display = "")
      }), !1)
    }

    <!-- Start of Sojern Tag: Please do not remove -->
    let btn = document.querySelector('#one-panel a.common-btn');
    if (btn) {
      btn.addEventListener('click', function () {
        (function () { /* Please fill the following values. */
          var params = {
            vb: btn.getAttribute("href"), /* Attraction Name */
          }; /* Please do not modify the below code. */
          try {
            params = Object.assign({}, sjrn_params, params);
          } catch (e) {
          }
          var cid = [];
          var paramsArr = [];
          var cidParams = [];
          var pl = document.createElement('iframe');
          var defaultParams = {"vid": "hot"};
          for (key in defaultParams) {
            params[key] = defaultParams[key];
          }
          for (key in cidParams) {
            cid.push(params[cidParams[key]]);
          }
          params.cid = cid.join('|');
          for (key in params) {
            paramsArr.push(key + '=' + encodeURIComponent(params[key]))
          }
          pl.type = 'text/html';
          pl.setAttribute('style', 'height:0; width: 0; display:none;');
          pl.async = true;
          pl.src = 'https://static.sojern.com/cip/a/71349.html?f_v=v6_js&p_v=4&' + paramsArr.join('&');
          (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(pl);
        })();
        return true;
      });
    }
    (function () { /* Please fill the following values. */
      var params = {
        pc: window.location.href /* Page Category */
      }; /* Please do not modify the below code. */
      try {
        params = Object.assign({}, sjrn_params, params);
      } catch (e) {
      }
      var cid = [];
      var paramsArr = [];
      var cidParams = [];
      var pl = document.createElement('iframe');
      var defaultParams = {"vid": "hot"};
      for (key in defaultParams) {
        params[key] = defaultParams[key];
      }
      for (key in cidParams) {
        cid.push(params[cidParams[key]]);
      }
      params.cid = cid.join('|');
      for (key in params) {
        paramsArr.push(key + '=' + encodeURIComponent(params[key]))
      }
      pl.type = 'text/html';
      pl.setAttribute('style', 'height:0; width: 0; display:none;');
      pl.async = true;
      pl.src = 'https://static.sojern.com/cip/a/71349.html?f_v=v6_js&p_v=4&' + paramsArr.join('&');
      (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(pl);
    })();
    return true;
    <!-- End of Sojern Tag: Please do not remove -->
  }(), !1);

})(); // custom js ends		


